var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoreNextChapterBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 427,
    height: 190,
    viewBox: "0 0 427 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "next-chapter-bg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n            #next-chapter-bg:hover path {\n                fill: rgba(255, 255, 255, .1);\n            }\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 163V28C0.5 23.8579 3.85788 20.5 8 20.5H398.444C400.003 20.5 401.523 20.9855 402.792 21.8891L423.348 36.5152C425.326 37.9223 426.5 40.1992 426.5 42.6262V163C426.5 167.142 423.142 170.5 419 170.5H311.878C309.583 170.5 307.386 171.428 305.786 173.072L292.497 186.73C291.085 188.181 289.147 189 287.122 189H226.5C224.408 189 222.411 188.127 220.992 186.591L197.476 161.147C194.651 158.091 190.03 157.529 186.556 159.819L172.228 169.262C171.003 170.07 169.568 170.5 168.101 170.5H32.5H8C3.85785 170.5 0.5 167.142 0.5 163Z",
    stroke: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoreNextChapterBg);
export default __webpack_public_path__ + "static/media/lore-next-chapter-bg.5730d34acc046c5ddcc3e76b25ca46df.svg";
export { ForwardRef as ReactComponent };